import { COLORS } from 'constants/colors'
import styled from 'styled-components'

export const Number = styled.div`
  align-items: center;
  background-color: ${COLORS.whiteF3};
  border-radius: 4px;
  display: flex;
  height: 32px;
  width: 55px;
  width: ${props => props.width || '80px'};
`
export const Count = styled.input`
  background-color: ${COLORS.whiteF3};
  border: 0;
  border-radius: 4px 0 0 4px;
  border-right: 1px solid ${COLORS.whiteD};
  color: ${COLORS.gray45};
  outline: 0;
  padding: 7px 13px 7px 15px;
  width: ${props => props.width || '43px'};

  &::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }
  :disabled {
    cursor: not-allowed;
  }
`

export const Arrows = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 36px;
`

export const Button = styled.div`
  height: 12px;
  position: absolute;
  width: 24px;
  cursor: pointer;
  user-select: none;
  width: 100%;
  ${props => props.up && 'top: 0;'}
  ${props => props.down && 'bottom: 0;'}
`
